import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";

// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import Sidebar from "components/Sidebar/Sidebar.jsx";

import dashboardRoutes from "routes/dashboard.jsx";

import appStyle from "assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.jsx";
import {connect} from "react-redux";
import logo from "assets/img/scope_markets_logo.svg";
//notifications
import Notification from "views/Notification/Notification.jsx";
import { getAuthPermissions } from "constants/authorisation.js";

var ps;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileOpen: false,
      miniActive: false, 
    }
    this.resizeFunction = this.resizeFunction.bind(this);
  }
  switchRoutes(){
    return (
      <Switch>
        {dashboardRoutes(this.props.auth.permissions).map((prop, key) => {
          if (prop.redirect)
            return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
          if (prop.collapse)
            return prop.views.map((prop, key) => {
              let perms = this.props.auth.permissions.filter((p)=> p.includes(prop.userPermission))
              if (
                    getAuthPermissions(this.props.auth.permissions,'ROUTES').includes(prop.path)
                    && perms.length !== 0
                 ) {
                   
                  return (
                    <Route path={prop.path} component={prop.component} key={key} />
                  );
              } else {
                return null;
              }
            });
          
          return <Route path={prop.path} component={prop.component} key={key} />;
        })}
      </Switch>
    )
  }
  componentDidMount() {
    window.addEventListener("resize", this.resizeFunction)

    if (this.refs.mainPanel && ((!ps) || (ps && !ps.element)) && navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.mainPanel, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    
  }
  componentWillUnmount() {
    if (ps && navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
    window.removeEventListener("resize", this.resizeFunction);
  }
  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname&& this.refs.mainPanel) {
      this.refs.mainPanel.scrollTop = 0;
      if (this.state.mobileOpen) {
        this.setState({ mobileOpen: false });
      }
    }
    if (this.refs.mainPanel && ((!ps) || (ps && !ps.element)) && navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.refs.mainPanel, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
  }
  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };
  getRoute() {
    return this.props.location.pathname !== "/maps/full-screen-maps";
  }
  sidebarMinimize() {
    this.setState({ miniActive: !this.state.miniActive });
  }
  resizeFunction() {
    if (window.innerWidth >= 960) {
      this.setState({ mobileOpen: false });
    }
  }
  render() {

    if(!this.props.auth.token)
      return <Redirect to='/login'/>
    const { classes, ...rest } = this.props;
    const mainPanel =
      classes.mainPanel +
      " " +
      cx({
        [classes.mainPanelSidebarMini]: this.state.miniActive,
        [classes.mainPanelWithPerfectScrollbar]:
          navigator.platform.indexOf("Win") > -1
      });
    return (
      <div className={classes.wrapper}>
        <Sidebar
          routes={dashboardRoutes(this.props.auth.permissions)}
          logoText={"Creative Tim"}
          logo={logo}
          /*image={image}*/
          handleDrawerToggle={this.handleDrawerToggle}
          open={this.state.mobileOpen}
          color="blue"
          bgColor="navy"
          miniActive={this.state.miniActive}
          {...rest}
        />
        <div className={mainPanel} ref="mainPanel">
          <Header
            sidebarMinimize={this.sidebarMinimize.bind(this)}
            miniActive={this.state.miniActive}
            routes={dashboardRoutes}
            handleDrawerToggle={this.handleDrawerToggle}
            {...rest}
          />
          {/* On the /maps/full-screen-maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
          {this.getRoute() ? (
            <div className={classes.content}>
              <div className={classes.container}>{this.switchRoutes()}</div>
            </div>
          ) : ( 
            <div className={classes.map}>{this.switchRoutes()}</div>
          )}
          {this.getRoute() ? <Footer fluid /> : null}

        </div>
          <Notification position='tr'/>
      </div>
    );
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
};

const state=(state)=>({
  auth:state.auth
})
export default withStyles(appStyle)(connect(state)(Dashboard));


// WEBPACK FOOTER //
// ./src/layouts/Dashboard.jsx